import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { trangThaiDangKyAnApi } from "../../../api/trangThaiDangKyAnApi";
import { IBaseResponeModel } from "../../../models/response/base-response";
import {
    eTrangThaiDangKyAnActionTypeIds,
    ITrangThaiDangKyAnDeleteStart,
    ITrangThaiDangKyAnLoadStart,
    ITrangThaiDangKyAnSaveStart,
} from "../../action-types/danh-muc/ITrangThaiDangKyAnActionTypes";
import { actions } from "../../actions/actionsWrapper";

function* loadTrangThaiDangKyAnWorker(_action: ITrangThaiDangKyAnLoadStart): any {
    const res: IBaseResponeModel = yield call([trangThaiDangKyAnApi, trangThaiDangKyAnApi.selectAll]);
    if (res && res.is_success) {
        yield put(actions.danhMucWrapper.trangThaiDangKyAn.LOAD_SUCCESS(res.data));
    } else {
        yield put(actions.danhMucWrapper.trangThaiDangKyAn.LOAD_ERROR(res?.message || "Không tải được danh sách trạng thái đăng ký ăn"));
    }
}

function* saveTrangThaiDangKyAnWorker(action: ITrangThaiDangKyAnSaveStart): any {
    let res: IBaseResponeModel;
    if (action.payload.id > 0) {
        res = yield call([trangThaiDangKyAnApi, trangThaiDangKyAnApi.update], action.payload);
    } else {
        res = yield call([trangThaiDangKyAnApi, trangThaiDangKyAnApi.insert], action.payload);
    }
    if (res && res.is_success) {
        yield put(actions.danhMucWrapper.trangThaiDangKyAn.SAVE_SUCCESS(undefined));
    } else {
        yield put(actions.danhMucWrapper.trangThaiDangKyAn.SAVE_ERROR(res?.message || "Không lưu được trạng thái đăng ký ăn"));
    }
}

function* deleteTrangThaiDangKyAnWorker(action: ITrangThaiDangKyAnDeleteStart): any {
    const res: IBaseResponeModel = yield call([trangThaiDangKyAnApi, trangThaiDangKyAnApi.delete], action.payload);
    if (res && res.is_success) {
        yield put(actions.danhMucWrapper.trangThaiDangKyAn.DELETE_SUCCESS(undefined));
    } else {
        yield put(actions.danhMucWrapper.trangThaiDangKyAn.DELETE_ERROR(res?.message || "Không xoá được trạng thái đăng ký ăn"));
    }
}

export function* trangThaiDangKyAnSaga(): any {
    yield takeLatest(eTrangThaiDangKyAnActionTypeIds.LOAD_START, loadTrangThaiDangKyAnWorker);
    yield takeEvery(eTrangThaiDangKyAnActionTypeIds.SAVE_START, saveTrangThaiDangKyAnWorker);
    yield takeEvery(eTrangThaiDangKyAnActionTypeIds.DELETE_START, deleteTrangThaiDangKyAnWorker);
}
